"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetWishlistOrderCommandHandler = void 0;
const domain_1 = require("../../domain");
const events_1 = require("../../domain/events");
const base_wishlist_command_handler_1 = require("../base-wishlist-command-handler");
class SetWishlistOrderCommandHandler extends base_wishlist_command_handler_1.BaseWishlistCommandHandler {
    constructor(wishlistRepository, eventEmitter) {
        super(wishlistRepository);
        this.wishlistRepository = wishlistRepository;
        this.eventEmitter = eventEmitter;
    }
    handle({ userId, targetStudyId, position, expectedState, isLocal }) {
        return __awaiter(this, void 0, void 0, function* () {
            const wishlist = yield this.getWishlist(userId, expectedState);
            let referenceStudyId = null;
            if (position !== 0) {
                if (!wishlist.favourites[position]) {
                    throw new domain_1.WishlistException('Position out of bounds');
                }
                referenceStudyId = wishlist.favourites[position].study.id;
            }
            wishlist.changeOrder(targetStudyId, referenceStudyId);
            yield this.wishlistRepository.setWishlistOrder(wishlist, targetStudyId, referenceStudyId);
            yield this.emitWishListOrderChangedEvent(userId, targetStudyId, referenceStudyId, wishlist.stateHash, new Date(), isLocal);
            return {
                resultingState: wishlist.stateHash,
            };
        });
    }
    emitWishListOrderChangedEvent(userId, targetStudyId, referenceStudyId, stateHash, dateAdded, isLocal) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.eventEmitter.emit(events_1.WishlistOrderChanged.EventType, events_1.WishlistOrderChanged.create(userId, targetStudyId, referenceStudyId, stateHash, dateAdded, isLocal));
        });
    }
}
exports.SetWishlistOrderCommandHandler = SetWishlistOrderCommandHandler;
